import { render, staticRenderFns } from "./CarbonEmissionsCalculations.vue?vue&type=template&id=68cf964a&scoped=true"
import script from "./CarbonEmissionsCalculations.vue?vue&type=script&setup=true&lang=ts"
export * from "./CarbonEmissionsCalculations.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CarbonEmissionsCalculations.vue?vue&type=style&index=0&id=68cf964a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cf964a",
  null
  
)

export default component.exports